import React, { FC, useState } from 'react';

import { LinkButton } from '@eika/button';
import { formatCurrencyValue } from '@eika/currency-input';
import { IconTypes } from '@eika/icon';

import { LaantypeWeb, SoeknadLaanContainerWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { maksLaanebeloep } from './laaneberegning';
import OmBeregningInfoModal from './omBeregningInfoModal';

interface Props {
    soeknadLaan: SoeknadLaanContainerWeb | undefined;
}

const Makslaanebeloep: FC<Props> = ({ soeknadLaan }) => {
    const { laanebeloep } = useTranslation();
    const [showModal, setShowModal] = useState<boolean>(false);

    return (
        <>
            <OmBeregningInfoModal showModal={showModal} setShowModal={setShowModal} />
            <div className="info-box row-gap">
                <span className="title">{laanebeloep.infoDittBoliglaanIDag}</span>
                <span>
                    <span>{`${
                        soeknadLaan?.laan.laantype === LaantypeWeb.KREDITT
                            ? laanebeloep.infoKredittrammeIDag
                            : laanebeloep.infoLaanIDag
                    }: `}</span>
                    <span className="bold">
                        {formatCurrencyValue(soeknadLaan?.laan.eksisterendeLaanebeloep || 0)} kr
                    </span>
                </span>
                <span>
                    <span>{`${laanebeloep.infoMaksimaltLaanebeleop}: `}</span>
                    <span className="bold">{formatCurrencyValue(maksLaanebeloep(soeknadLaan))} kr</span>
                </span>
                <LinkButton
                    icon={IconTypes.INFO_24}
                    data-track-id="kreditt-boliglaan-laanebeloep-maksbeloep-info"
                    data-track-linkname="om-beregning"
                    onClick={() => setShowModal(true)}
                >
                    {laanebeloep.infoLinkOmBergning}
                </LinkButton>
            </div>
        </>
    );
};

export default Makslaanebeloep;
